import { render } from "./ThePathsIdentity.vue?vue&type=template&id=2680768e&scoped=true"
import script from "./ThePathsIdentity.vue?vue&type=script&lang=js"
export * from "./ThePathsIdentity.vue?vue&type=script&lang=js"

import "./ThePathsIdentity.vue?vue&type=style&index=0&id=2680768e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2680768e"]])

export default __exports__